import { Injectable } from '@angular/core';
import { AbstractSearchItemsService } from './abstract-search-items.service';
import { TaskSearchItemsAction } from '../../task-search/task-search-item/action/task-search-items.action';
import { SearchItem } from '../../../models/search-item';
import { SearchOperator } from '../../../models/field';
import { AuthenticationService } from '../../../../entry-routes/authentication/authentication.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TaskSearchItemsService extends AbstractSearchItemsService {

  constructor(
    private taskSearchItemAction: TaskSearchItemsAction,
    private authenticationService: AuthenticationService,
    private translateService: TranslateService
  ) {
    super();
  }

  public getSearchItemsAction(): TaskSearchItemsAction {
    return this.taskSearchItemAction;
  }

  private getNewCurrentUserAsAssignedSearchItem() : SearchItem {
    const currentUserAsAssigneeSearchItem : SearchItem =  new SearchItem();
    currentUserAsAssigneeSearchItem.id = -1;
    currentUserAsAssigneeSearchItem.keyword = this.translateService.instant('TASKS.assigned');
    currentUserAsAssigneeSearchItem.path = 'cdx_wkf.assignation.assignee';
    currentUserAsAssigneeSearchItem.operator = SearchOperator.e;
    currentUserAsAssigneeSearchItem.value = this.authenticationService.getUserCredentials().id.toString() ;
    currentUserAsAssigneeSearchItem.label = this.authenticationService.getUserCredentials().firstname + ' ' + this.authenticationService.getUserCredentials().lastname;
    return currentUserAsAssigneeSearchItem;
  }

  private getNewCurrentUserAsCandidateUserSearchItem() : SearchItem {
    const currentUserAsAssigneeSearchItem : SearchItem =  new SearchItem();
    currentUserAsAssigneeSearchItem.id = -1;
    currentUserAsAssigneeSearchItem.keyword = this.translateService.instant('TASKS.candidateUser');
    currentUserAsAssigneeSearchItem.path = 'cdx_wkf.assignation.candidate_user';
    currentUserAsAssigneeSearchItem.operator = SearchOperator.e;
    currentUserAsAssigneeSearchItem.value = this.authenticationService.getUserCredentials().id.toString() ;
    return currentUserAsAssigneeSearchItem;
  }

  private getNewAssigneeIsNullSearchItem() : SearchItem {
    const currentUserAsAssigneeSearchItem : SearchItem =  new SearchItem();
    currentUserAsAssigneeSearchItem.id = -1;
    currentUserAsAssigneeSearchItem.keyword = this.translateService.instant('TASKS.assigned');
    currentUserAsAssigneeSearchItem.path = 'cdx_wkf.assignation.assignee';
    currentUserAsAssigneeSearchItem.operator = SearchOperator.n;
    currentUserAsAssigneeSearchItem.value = 'true';
    return currentUserAsAssigneeSearchItem;
  }

  setItemAssigneeIsNull() {
    this.setItems([this.getNewAssigneeIsNullSearchItem()]);
  }

  setItemAssigneeIsCurrentUser() {
    this.setItems([this.getNewCurrentUserAsAssignedSearchItem()]);
  }

  setItemCurrentUserAsAssignedAndItemAssigneeIsNull() {
    this.setItems([this.getNewCurrentUserAsAssignedSearchItem(),this.getNewAssigneeIsNullSearchItem()]);
  }

  private hasSearchItem(searchItems: SearchItem[], searchItemToTest: SearchItem) : boolean {
    let found = false;
    const currentUserAsAssigneeSearchItem = searchItems.find( item =>
      item.keyword === searchItemToTest.keyword &&
      item.path === searchItemToTest.path &&
      item.operator === searchItemToTest.operator &&
      item.value === searchItemToTest.value
    )
    if(!!currentUserAsAssigneeSearchItem) {
      found = true;
    }
    return found;
  }

  hasItemCurrentUserAsAssigned( searchItems: SearchItem[] ) {
    let found = false;
    const currentUserAsAssigneeSearchItemTest = this.getNewCurrentUserAsAssignedSearchItem();
    found = this.hasSearchItem(searchItems, currentUserAsAssigneeSearchItemTest);
    return found;
  }

  hasItemCurrentUserAsCandidateUser( searchItems: SearchItem[] ) {
    let found = false;
    const currentUserAsCandidateUserSearchItemTest = this.getNewCurrentUserAsCandidateUserSearchItem();
    found = this.hasSearchItem(searchItems, currentUserAsCandidateUserSearchItemTest);
    return found;
  }

  hasItemAssigneeIsNull( searchItems: SearchItem[] ) {
    let found = false;
    const currentUserAsAssigneeSearchItemTest = this.getNewAssigneeIsNullSearchItem();
    found = this.hasSearchItem(searchItems, currentUserAsAssigneeSearchItemTest);
    return found;
  }

  hasItemCurrentUserAsAssignedAndItemAssigneeIsNull( searchItems: SearchItem[] ) {
    let found = false;
    found = this.hasItemCurrentUserAsAssigned(searchItems ) &&  this.hasItemAssigneeIsNull(searchItems)
    return found;
  }
  removeItemCurrentUserAsAssigned() {
    const currentUserAsAssigneeSearchItem = this.getNewCurrentUserAsAssignedSearchItem();
    this.deleteItem(currentUserAsAssigneeSearchItem);
  }

  removeItemCurrentUserAsCandidateUser() {
    const currentUserAsCandidateUserSearchItem = this.getNewCurrentUserAsCandidateUserSearchItem();
    this.deleteItem(currentUserAsCandidateUserSearchItem);
  }

  removeItemAssigneeIsNull() {
    const currentUserAsCandidateUserSearchItem = this.getNewAssigneeIsNullSearchItem();
    this.deleteItem(currentUserAsCandidateUserSearchItem);
  }

}
